import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES } from '../../config/url.servicio'

/*
  Generated class for the ClientesCorreosProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ClientesCorreosProvider {

  constructor(public http: Http) {
    console.log('Hello ClientesCorreosProvider Provider');
  }

  buscar() {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      return this.http.get(`${url_servicio}/procedure?name=clientesCorreosElectronicos`);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=clientesCorreosElectronicos`)
        .map((data)=> data.json())
   }
  }

  guardar(clienteCorreo: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: clienteCorreo.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientesCorreosElectronicos",
          ...clienteCorreo
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, clienteCorreo, options)
        .map((data) => data.json()
        , error => console.log(error))
   }
  }

  actualizar(clienteCorreo: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: clienteCorreo.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientesCorreosElectronicos",
          ...clienteCorreo
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.put(`${url}/query`, clienteCorreo, options)
   }
  }

  eliminar(clienteCorreo: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: clienteCorreo.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientesCorreosElectronicos",
          ...clienteCorreo
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&clientesCorreosElectronicosId=${clienteCorreo.clientesCorreosElectronicosId}&nombreTabla=clientesCorreosElectronicos`, options)
   }
  }
}



// WEBPACK FOOTER //
// ./src/providers/clientes-correos/clientes-correos.ts